import { useAutoLoadMore } from '@/lib/use-auto-load-more'
import { type useLoadMore } from '@/lib/use-load-more'
import { LoadMoreButton } from '@/ui/load-more-button'

type Pager = ReturnType<typeof useLoadMore<unknown>>

export function LoadMoreSentinel({
  pager,
  root,
  paused = false,
  className,
}: {
  pager: Pager
  root: HTMLElement | null
  paused?: boolean
  className?: string
}) {
  const { sentinelRef } = useAutoLoadMore(pager, { root, paused })

  return (
    <>
      <div data-slot="load-more-sentinel" aria-hidden="true" ref={sentinelRef} />
      <LoadMoreButton pager={pager} visibleStatus retryOnFailure className={className} />
    </>
  )
}
